<div class="calendar-container row" id="cal-container">

    <div *ngIf="notBookable" class="col-md-12">
        <div class="mb-4 alert-danger">
            <span class="validation-msg" [innerHTML]="'COMMON.NOT_BOOKABLE' | translate | noSanitise"></span>
        </div>
    </div>

    <div class="calendar-side col-xs-12 col-md-6 col-lg-4">
        <mat-calendar #calendar [selected]="selectedDate" [minDate]="minDate" [maxDate]="maxDate"
            (selectedChange)="updateSlots($event)" [dateFilter]="unavailableDates">
        </mat-calendar>
    </div>

    <div class="col-xs-12 col-md-6 col-lg-5 mat-card">
        <h4 class="selected-date text-center">{{selectedDate | date : 'EEEE d MMMM' }}</h4>
        <hr />

        <div *ngIf="selectedDate && collectionDate" class="col-sm-12 mt-3">
            <p class="alert-warning" tabindex="0">
                {{'CALENDAR_COMPONENT.COLLECTION_DATE_ALERT' | translate:{collectionDate: collectionDate | date : 'EEEE d MMMM'} }}
            </p>
        </div>
        
        <p *ngIf="selectedSlots.length >= 1" class="col-sm-12">
            {{'CALENDAR_COMPONENT.SELECTED_SLOTS_SUBHEADING' | translate}}
        </p>

        <h5 *ngIf="presentendSlots.length === 0" class="text-center">No slots available for
            {{selectedDate | date : 'EEEE d MMMM'}}</h5>


        <div *ngFor="let slot of selectedSlots" class="col-xs-12 col-md-12">
            <div class="chip">
                <mat-icon class="person-icon">
                    person
                </mat-icon>
                <span class="pill-text"> {{slot.start | date: 'EEEE d MMMM, HH:mm'}} </span>

                <mat-icon (click)="removeDate(slot)" class="cancel-button">
                    delete
                </mat-icon>
            </div>
        </div>

        <p *ngIf="selectedSlots.length >= 1" class="col-sm-12 mt-2">
            {{'CALENDAR_COMPONENT.ALETERNATE_SLOT' | translate}}
        </p>
    </div>

    <div class="slot-info-div slot-selection col-xs-12 col-md-12" role="radiogroup" *ngIf="!notBookable">
        <h4>{{'CALENDAR_COMPONENT.AVAILABLE_SLOTS' | translate}}</h4>
        <hr />
        <h5 *ngIf="presentendSlots.length === 0" class="text-center">No slots available for
            {{selectedDate | date : 'EEEE d MMMM'}}</h5>
        <div class="slot-button-group divide-basis-6 col-6 col-sm-3 col-md-2" *ngFor="let slot of presentendSlots">
            <button class="btn slot-btn"
                *ngIf="slot.available == true && this.selectedSlots.length == this.requiredAvailability"
                matTooltip=" {{'CALENDAR_COMPONENT.REMOVE_SELECTED_SLOT' | translate}}"
                [ngClass]="selectedSlots.indexOf(slot) !== -1 ? 'slot-selected' : ''"
                (click)="selectSlot(slot)">{{slot?.start | date: 'HH:mm' }}</button>
            <button class="btn slot-btn"
                *ngIf="slot.available == true && this.selectedSlots.length != this.requiredAvailability"
                [ngClass]="selectedSlots.indexOf(slot) !== -1 ? 'slot-selected' : ''"
                (click)="selectSlot(slot)">{{slot?.start | date: 'HH:mm' }}</button>
        </div>
    </div>
</div>